'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _commonFormsy = require('../common-formsy');

var _PriorFundingFormGroup = require('./PriorFundingFormGroup');

var _PriorFundingFormGroup2 = _interopRequireDefault(_PriorFundingFormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FORM_REF = 'FORM';

var PriorFundingModal = (_dec = (0, _mobxReact.inject)('PriorFundingStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(PriorFundingModal, _Component);

  function PriorFundingModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PriorFundingModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PriorFundingModal.__proto__ || Object.getPrototypeOf(PriorFundingModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'buyoutAmount', _descriptor, _this), _initDefineProp(_this, 'expirationDate', _descriptor2, _this), _initDefineProp(_this, 'funderName', _descriptor3, _this), _initDefineProp(_this, 'linkApplication', _descriptor4, _this), _initDefineProp(_this, 'priorFundingId', _descriptor5, _this), _initDefineProp(_this, 'submitErrors', _descriptor6, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PriorFundingModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.componentWillReceiveProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.linkApplication = nextProps.application.id;
      if (nextProps.priorFunding !== undefined) {
        var _nextProps$priorFundi = nextProps.priorFunding,
            buyout_amount = _nextProps$priorFundi.buyout_amount,
            expiration_date = _nextProps$priorFundi.expiration_date,
            funder_name = _nextProps$priorFundi.funder_name,
            id = _nextProps$priorFundi.id;


        this.buyoutAmount = buyout_amount;
        this.expirationDate = expiration_date;
        this.funderName = funder_name;
        this.priorFundingId = id;
      }
    }
  }, {
    key: 'handleValidSubmit',
    value: function handleValidSubmit(model, resetForm, invalidateForm) {
      var _props = this.props,
          _case = _props._case,
          onClose = _props.onClose,
          PriorFundingStore = _props.PriorFundingStore;


      var data = {
        buyout_amount: model.prior_funding.buyout_amount || null,
        expiration_date: model.prior_funding.expiration_date || null,
        funder_name: model.prior_funding.funder_name || '',
        id: this.priorFundingId
      };
      if (this.linkApplication) {
        data.link_application = this.linkApplication;
      }
      PriorFundingStore.create(_case, data);
      onClose();
    }
  }, {
    key: 'handleSubmitErrorsChange',
    value: function handleSubmitErrorsChange(submitErrors) {
      this.submitErrors = submitErrors;
    }
  }, {
    key: 'handleFormChange',
    value: function handleFormChange(data) {
      this.buyoutAmount = (0, _get3.default)(data, 'prior_funding.buyout_amount');
      this.expirationDate = (0, _get3.default)(data, 'prior_funding.expiration_date');
      this.funderName = (0, _get3.default)(data, 'prior_funding.funder_name');
    }
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.onClose;


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: onClose },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            onChange: this.handleFormChange,
            onSubmitErrorsChange: this.handleSubmitErrorsChange,
            onValidSubmit: this.handleValidSubmit,
            ref: FORM_REF
          },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              'Buyout Info'
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            _react2.default.createElement(_commonFormsy.Input, {
              name: 'link_application',
              type: 'hidden',
              value: this.props.application.id
            }),
            _react2.default.createElement(_PriorFundingFormGroup2.default, {
              priorFunding: {
                buyout_amount: this.buyoutAmount,
                expiration_date: this.expirationDate,
                funder_name: this.funderName
              },
              required: false })
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: !!(this.submitErrors || this.buyoutAmount < 0), bsStyle: 'primary', type: 'submit' },
                'Save'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PriorFundingModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  application: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  priorFunding: _propTypes2.default.object,
  PriorFundingStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'buyoutAmount', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'expirationDate', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'funderName', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'linkApplication', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'priorFundingId', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'submitErrors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = PriorFundingModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FORM_REF, 'FORM_REF', '/app/src/components/common-prior-fundings/PriorFundingModal.js');
  reactHotLoader.register(PriorFundingModal, 'PriorFundingModal', '/app/src/components/common-prior-fundings/PriorFundingModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-prior-fundings/PriorFundingModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2NvbW1vbi1wcmlvci1mdW5kaW5ncy9QcmlvckZ1bmRpbmdNb2RhbC5qcyJdLCJuYW1lcyI6WyJGT1JNX1JFRiIsIlByaW9yRnVuZGluZ01vZGFsIiwiYXV0b0JpbmRNZXRob2RzIiwib2JzZXJ2ZXIiLCJjb21wb25lbnRXaWxsUmVjZWl2ZVByb3BzIiwicHJvcHMiLCJuZXh0UHJvcHMiLCJsaW5rQXBwbGljYXRpb24iLCJhcHBsaWNhdGlvbiIsImlkIiwicHJpb3JGdW5kaW5nIiwidW5kZWZpbmVkIiwiYnV5b3V0X2Ftb3VudCIsImV4cGlyYXRpb25fZGF0ZSIsImZ1bmRlcl9uYW1lIiwiYnV5b3V0QW1vdW50IiwiZXhwaXJhdGlvbkRhdGUiLCJmdW5kZXJOYW1lIiwicHJpb3JGdW5kaW5nSWQiLCJtb2RlbCIsInJlc2V0Rm9ybSIsImludmFsaWRhdGVGb3JtIiwiX2Nhc2UiLCJvbkNsb3NlIiwiUHJpb3JGdW5kaW5nU3RvcmUiLCJkYXRhIiwicHJpb3JfZnVuZGluZyIsImxpbmtfYXBwbGljYXRpb24iLCJjcmVhdGUiLCJzdWJtaXRFcnJvcnMiLCJoYW5kbGVGb3JtQ2hhbmdlIiwiaGFuZGxlU3VibWl0RXJyb3JzQ2hhbmdlIiwiaGFuZGxlVmFsaWRTdWJtaXQiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJvYmplY3QiLCJpc1JlcXVpcmVkIiwiZnVuYyIsIm9ic2VydmFibGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7O0FBU0E7O0FBS0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxXQUFXLE1BQWpCOztJQUtNQyxpQixXQUhMLHVCQUFPLG1CQUFQLEMsb0JBQ0FDLGdDLGVBQ0FDLG1COzs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lDQVd1QjtBQUNwQixXQUFLQyx5QkFBTCxDQUErQixLQUFLQyxLQUFwQztBQUNEOzs7OENBRTBCQyxTLEVBQVc7QUFDcEMsV0FBS0MsZUFBTCxHQUF1QkQsVUFBVUUsV0FBVixDQUFzQkMsRUFBN0M7QUFDQSxVQUFJSCxVQUFVSSxZQUFWLEtBQTJCQyxTQUEvQixFQUEwQztBQUFBLG9DQU1wQ0wsVUFBVUksWUFOMEI7QUFBQSxZQUV0Q0UsYUFGc0MseUJBRXRDQSxhQUZzQztBQUFBLFlBR3RDQyxlQUhzQyx5QkFHdENBLGVBSHNDO0FBQUEsWUFJdENDLFdBSnNDLHlCQUl0Q0EsV0FKc0M7QUFBQSxZQUt0Q0wsRUFMc0MseUJBS3RDQSxFQUxzQzs7O0FBUXhDLGFBQUtNLFlBQUwsR0FBb0JILGFBQXBCO0FBQ0EsYUFBS0ksY0FBTCxHQUFzQkgsZUFBdEI7QUFDQSxhQUFLSSxVQUFMLEdBQWtCSCxXQUFsQjtBQUNBLGFBQUtJLGNBQUwsR0FBc0JULEVBQXRCO0FBQ0Q7QUFDRjs7O3NDQUVrQlUsSyxFQUFPQyxTLEVBQVdDLGMsRUFBZ0I7QUFBQSxtQkFLL0MsS0FBS2hCLEtBTDBDO0FBQUEsVUFFakRpQixLQUZpRCxVQUVqREEsS0FGaUQ7QUFBQSxVQUdqREMsT0FIaUQsVUFHakRBLE9BSGlEO0FBQUEsVUFJakRDLGlCQUppRCxVQUlqREEsaUJBSmlEOzs7QUFPbkQsVUFBTUMsT0FBTztBQUNYYix1QkFBZU8sTUFBTU8sYUFBTixDQUFvQmQsYUFBcEIsSUFBcUMsSUFEekM7QUFFWEMseUJBQWlCTSxNQUFNTyxhQUFOLENBQW9CYixlQUFwQixJQUF1QyxJQUY3QztBQUdYQyxxQkFBYUssTUFBTU8sYUFBTixDQUFvQlosV0FBcEIsSUFBbUMsRUFIckM7QUFJWEwsWUFBSSxLQUFLUztBQUpFLE9BQWI7QUFNQSxVQUFJLEtBQUtYLGVBQVQsRUFBMEI7QUFDeEJrQixhQUFLRSxnQkFBTCxHQUF3QixLQUFLcEIsZUFBN0I7QUFDRDtBQUNEaUIsd0JBQWtCSSxNQUFsQixDQUF5Qk4sS0FBekIsRUFBZ0NHLElBQWhDO0FBQ0FGO0FBQ0Q7Ozs2Q0FFeUJNLFksRUFBYztBQUN0QyxXQUFLQSxZQUFMLEdBQW9CQSxZQUFwQjtBQUNEOzs7cUNBRWlCSixJLEVBQU07QUFDdEIsV0FBS1YsWUFBTCxHQUFvQixtQkFBSVUsSUFBSixFQUFVLDZCQUFWLENBQXBCO0FBQ0EsV0FBS1QsY0FBTCxHQUFzQixtQkFBSVMsSUFBSixFQUFVLCtCQUFWLENBQXRCO0FBQ0EsV0FBS1IsVUFBTCxHQUFrQixtQkFBSVEsSUFBSixFQUFVLDJCQUFWLENBQWxCO0FBQ0Q7Ozs2QkFFUztBQUFBLFVBQ0FGLE9BREEsR0FDWSxLQUFLbEIsS0FEakIsQ0FDQWtCLE9BREE7OztBQUdSLGFBQ0U7QUFBQyx1QkFBRDtBQUFBLFVBQU8sVUFBUCxFQUFZLFFBQVFBLE9BQXBCO0FBQ0U7QUFBQyw0QkFBRDtBQUFBO0FBQ0Usc0JBQVUsS0FBS08sZ0JBRGpCO0FBRUUsa0NBQXNCLEtBQUtDLHdCQUY3QjtBQUdFLDJCQUFlLEtBQUtDLGlCQUh0QjtBQUlFLGlCQUFLaEM7QUFKUDtBQU1FO0FBQUMsMkJBQUQsQ0FBTyxNQUFQO0FBQUEsY0FBYyxpQkFBZDtBQUNFO0FBQUMsNkJBQUQsQ0FBTyxLQUFQO0FBQUE7QUFBQTtBQUFBO0FBREYsV0FORjtBQVNFO0FBQUMsMkJBQUQsQ0FBTyxJQUFQO0FBQUE7QUFDRSwwQ0FBQyxtQkFBRDtBQUNFLG9CQUFLLGtCQURQO0FBRUUsb0JBQUssUUFGUDtBQUdFLHFCQUFPLEtBQUtLLEtBQUwsQ0FBV0csV0FBWCxDQUF1QkM7QUFIaEMsY0FERjtBQU1FLDBDQUFDLCtCQUFEO0FBQ0UsNEJBQWM7QUFDWkcsK0JBQWUsS0FBS0csWUFEUjtBQUVaRixpQ0FBaUIsS0FBS0csY0FGVjtBQUdaRiw2QkFBYSxLQUFLRztBQUhOLGVBRGhCO0FBTUUsd0JBQVUsS0FOWjtBQU5GLFdBVEY7QUF1QkU7QUFBQywyQkFBRCxDQUFPLE1BQVA7QUFBQTtBQUNFO0FBQUMscUNBQUQ7QUFBQSxnQkFBZSxXQUFVLFlBQXpCO0FBQ0U7QUFBQyxnQ0FBRDtBQUFBLGtCQUFRLFNBQVNNLE9BQWpCO0FBQUE7QUFBQSxlQURGO0FBRUU7QUFBQyxnQ0FBRDtBQUFBLGtCQUFRLFVBQVUsQ0FBQyxFQUFFLEtBQUtNLFlBQUwsSUFBcUIsS0FBS2QsWUFBTCxHQUFvQixDQUEzQyxDQUFuQixFQUFrRSxTQUFRLFNBQTFFLEVBQW9GLE1BQUssUUFBekY7QUFBQTtBQUFBO0FBRkY7QUFERjtBQXZCRjtBQURGLE9BREY7QUFrQ0Q7Ozs7Ozs7Ozs7O0VBbEc2QmtCLGdCLFdBb0d2QkMsUyxHQUFZO0FBQ2pCWixTQUFPYSxvQkFBVUMsTUFBVixDQUFpQkMsVUFEUDtBQUVqQjdCLGVBQWEyQixvQkFBVUMsTUFBVixDQUFpQkMsVUFGYjtBQUdqQmQsV0FBU1ksb0JBQVVHLElBQVYsQ0FBZUQsVUFIUDtBQUlqQjNCLGdCQUFjeUIsb0JBQVVDLE1BSlA7QUFLakJaLHFCQUFtQlcsb0JBQVVDLE1BQVYsQ0FBaUJDO0FBTG5CLEMsd0ZBbEdsQkUsZ0I7OzttRkFDQUEsZ0I7OzsrRUFDQUEsZ0I7OztvRkFDQUEsZ0I7OzttRkFDQUEsZ0I7OztpRkFFQUEsZ0I7OztXQUEwQixLOzs7ZUFxR2R0QyxpQjs7Ozs7Ozs7Ozs7MEJBbEhURCxROzBCQUtBQyxpQiIsImZpbGUiOiJQcmlvckZ1bmRpbmdNb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBvYnNlcnZhYmxlIH0gZnJvbSAnbW9ieCc7XG5pbXBvcnQgeyBvYnNlcnZlciwgaW5qZWN0IH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5pbXBvcnQgeyBnZXQgfSBmcm9tICdsb2Rhc2gnO1xuXG5pbXBvcnQge1xuICBCdXR0b24sXG4gIEJ1dHRvblRvb2xiYXIsXG4gIE1vZGFsLFxufSBmcm9tICdyZWFjdC1ib290c3RyYXAnO1xuXG5pbXBvcnQge1xuICBGb3JtLFxuICBJbnB1dCxcbn0gZnJvbSAnLi4vY29tbW9uLWZvcm1zeSc7XG5cbmltcG9ydCBQcmlvckZ1bmRpbmdGb3JtR3JvdXAgZnJvbSAnLi9QcmlvckZ1bmRpbmdGb3JtR3JvdXAnO1xuXG5jb25zdCBGT1JNX1JFRiA9ICdGT1JNJztcblxuQGluamVjdCgnUHJpb3JGdW5kaW5nU3RvcmUnKVxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBQcmlvckZ1bmRpbmdNb2RhbCBleHRlbmRzIENvbXBvbmVudCB7XG4gIC8vIGZvcm0gZmllbGRzXG4gIEBvYnNlcnZhYmxlIGJ1eW91dEFtb3VudDtcbiAgQG9ic2VydmFibGUgZXhwaXJhdGlvbkRhdGU7XG4gIEBvYnNlcnZhYmxlIGZ1bmRlck5hbWU7XG4gIEBvYnNlcnZhYmxlIGxpbmtBcHBsaWNhdGlvbjtcbiAgQG9ic2VydmFibGUgcHJpb3JGdW5kaW5nSWQ7XG5cbiAgQG9ic2VydmFibGUgc3VibWl0RXJyb3JzID0gZmFsc2U7XG5cbiAgY29tcG9uZW50V2lsbE1vdW50ICgpIHtcbiAgICB0aGlzLmNvbXBvbmVudFdpbGxSZWNlaXZlUHJvcHModGhpcy5wcm9wcyk7XG4gIH1cblxuICBjb21wb25lbnRXaWxsUmVjZWl2ZVByb3BzIChuZXh0UHJvcHMpIHtcbiAgICB0aGlzLmxpbmtBcHBsaWNhdGlvbiA9IG5leHRQcm9wcy5hcHBsaWNhdGlvbi5pZDtcbiAgICBpZiAobmV4dFByb3BzLnByaW9yRnVuZGluZyAhPT0gdW5kZWZpbmVkKSB7XG4gICAgICBjb25zdCB7XG4gICAgICAgIGJ1eW91dF9hbW91bnQsXG4gICAgICAgIGV4cGlyYXRpb25fZGF0ZSxcbiAgICAgICAgZnVuZGVyX25hbWUsXG4gICAgICAgIGlkLFxuICAgICAgfSA9IG5leHRQcm9wcy5wcmlvckZ1bmRpbmc7XG5cbiAgICAgIHRoaXMuYnV5b3V0QW1vdW50ID0gYnV5b3V0X2Ftb3VudDtcbiAgICAgIHRoaXMuZXhwaXJhdGlvbkRhdGUgPSBleHBpcmF0aW9uX2RhdGU7XG4gICAgICB0aGlzLmZ1bmRlck5hbWUgPSBmdW5kZXJfbmFtZTtcbiAgICAgIHRoaXMucHJpb3JGdW5kaW5nSWQgPSBpZDtcbiAgICB9XG4gIH1cblxuICBoYW5kbGVWYWxpZFN1Ym1pdCAobW9kZWwsIHJlc2V0Rm9ybSwgaW52YWxpZGF0ZUZvcm0pIHtcbiAgICBjb25zdCB7XG4gICAgICBfY2FzZSxcbiAgICAgIG9uQ2xvc2UsXG4gICAgICBQcmlvckZ1bmRpbmdTdG9yZSxcbiAgICB9ID0gdGhpcy5wcm9wcztcblxuICAgIGNvbnN0IGRhdGEgPSB7XG4gICAgICBidXlvdXRfYW1vdW50OiBtb2RlbC5wcmlvcl9mdW5kaW5nLmJ1eW91dF9hbW91bnQgfHwgbnVsbCxcbiAgICAgIGV4cGlyYXRpb25fZGF0ZTogbW9kZWwucHJpb3JfZnVuZGluZy5leHBpcmF0aW9uX2RhdGUgfHwgbnVsbCxcbiAgICAgIGZ1bmRlcl9uYW1lOiBtb2RlbC5wcmlvcl9mdW5kaW5nLmZ1bmRlcl9uYW1lIHx8ICcnLFxuICAgICAgaWQ6IHRoaXMucHJpb3JGdW5kaW5nSWQsXG4gICAgfTtcbiAgICBpZiAodGhpcy5saW5rQXBwbGljYXRpb24pIHtcbiAgICAgIGRhdGEubGlua19hcHBsaWNhdGlvbiA9IHRoaXMubGlua0FwcGxpY2F0aW9uO1xuICAgIH1cbiAgICBQcmlvckZ1bmRpbmdTdG9yZS5jcmVhdGUoX2Nhc2UsIGRhdGEpO1xuICAgIG9uQ2xvc2UoKTtcbiAgfVxuXG4gIGhhbmRsZVN1Ym1pdEVycm9yc0NoYW5nZSAoc3VibWl0RXJyb3JzKSB7XG4gICAgdGhpcy5zdWJtaXRFcnJvcnMgPSBzdWJtaXRFcnJvcnM7XG4gIH1cblxuICBoYW5kbGVGb3JtQ2hhbmdlIChkYXRhKSB7XG4gICAgdGhpcy5idXlvdXRBbW91bnQgPSBnZXQoZGF0YSwgJ3ByaW9yX2Z1bmRpbmcuYnV5b3V0X2Ftb3VudCcpO1xuICAgIHRoaXMuZXhwaXJhdGlvbkRhdGUgPSBnZXQoZGF0YSwgJ3ByaW9yX2Z1bmRpbmcuZXhwaXJhdGlvbl9kYXRlJyk7XG4gICAgdGhpcy5mdW5kZXJOYW1lID0gZ2V0KGRhdGEsICdwcmlvcl9mdW5kaW5nLmZ1bmRlcl9uYW1lJyk7XG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgb25DbG9zZSB9ID0gdGhpcy5wcm9wcztcblxuICAgIHJldHVybiAoXG4gICAgICA8TW9kYWwgc2hvdyBvbkhpZGU9e29uQ2xvc2V9PlxuICAgICAgICA8Rm9ybVxuICAgICAgICAgIG9uQ2hhbmdlPXt0aGlzLmhhbmRsZUZvcm1DaGFuZ2V9XG4gICAgICAgICAgb25TdWJtaXRFcnJvcnNDaGFuZ2U9e3RoaXMuaGFuZGxlU3VibWl0RXJyb3JzQ2hhbmdlfVxuICAgICAgICAgIG9uVmFsaWRTdWJtaXQ9e3RoaXMuaGFuZGxlVmFsaWRTdWJtaXR9XG4gICAgICAgICAgcmVmPXtGT1JNX1JFRn1cbiAgICAgICAgPlxuICAgICAgICAgIDxNb2RhbC5IZWFkZXIgY2xvc2VCdXR0b24+XG4gICAgICAgICAgICA8TW9kYWwuVGl0bGU+QnV5b3V0IEluZm88L01vZGFsLlRpdGxlPlxuICAgICAgICAgIDwvTW9kYWwuSGVhZGVyPlxuICAgICAgICAgIDxNb2RhbC5Cb2R5PlxuICAgICAgICAgICAgPElucHV0XG4gICAgICAgICAgICAgIG5hbWU9J2xpbmtfYXBwbGljYXRpb24nXG4gICAgICAgICAgICAgIHR5cGU9J2hpZGRlbidcbiAgICAgICAgICAgICAgdmFsdWU9e3RoaXMucHJvcHMuYXBwbGljYXRpb24uaWR9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPFByaW9yRnVuZGluZ0Zvcm1Hcm91cFxuICAgICAgICAgICAgICBwcmlvckZ1bmRpbmc9e3tcbiAgICAgICAgICAgICAgICBidXlvdXRfYW1vdW50OiB0aGlzLmJ1eW91dEFtb3VudCxcbiAgICAgICAgICAgICAgICBleHBpcmF0aW9uX2RhdGU6IHRoaXMuZXhwaXJhdGlvbkRhdGUsXG4gICAgICAgICAgICAgICAgZnVuZGVyX25hbWU6IHRoaXMuZnVuZGVyTmFtZSxcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgcmVxdWlyZWQ9e2ZhbHNlfSAvPlxuICAgICAgICAgIDwvTW9kYWwuQm9keT5cbiAgICAgICAgICA8TW9kYWwuRm9vdGVyPlxuICAgICAgICAgICAgPEJ1dHRvblRvb2xiYXIgY2xhc3NOYW1lPSdwdWxsLXJpZ2h0Jz5cbiAgICAgICAgICAgICAgPEJ1dHRvbiBvbkNsaWNrPXtvbkNsb3NlfT5DYW5jZWw8L0J1dHRvbj5cbiAgICAgICAgICAgICAgPEJ1dHRvbiBkaXNhYmxlZD17ISEodGhpcy5zdWJtaXRFcnJvcnMgfHwgdGhpcy5idXlvdXRBbW91bnQgPCAwKX0gYnNTdHlsZT0ncHJpbWFyeScgdHlwZT0nc3VibWl0Jz5TYXZlPC9CdXR0b24+XG4gICAgICAgICAgICA8L0J1dHRvblRvb2xiYXI+XG4gICAgICAgICAgPC9Nb2RhbC5Gb290ZXI+XG4gICAgICAgIDwvRm9ybT5cbiAgICAgIDwvTW9kYWw+XG4gICAgKTtcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgX2Nhc2U6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgICBhcHBsaWNhdGlvbjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICAgIG9uQ2xvc2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gICAgcHJpb3JGdW5kaW5nOiBQcm9wVHlwZXMub2JqZWN0LFxuICAgIFByaW9yRnVuZGluZ1N0b3JlOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IFByaW9yRnVuZGluZ01vZGFsO1xuIl19